import { createContext, useContext } from 'react';

// The admin-authored campaign variant when the workshop renders under /for/:slug
// (see routes/LandingPage); null on every other Unlimited mount.
export const LandingPageVariantContext = createContext(null);

export const useLandingPageVariant = () => useContext(LandingPageVariantContext);
